<!-- TEMPLATE -->
<template>
  <div class="product-summary">
    <div class='row'>
      <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
        <dean-section-title content='true'>
                        <span slot='title'>
                            <span class='avenir-heavy'>Producttermijnen</span>
                        </span>
          <dean-section-title-item
              :icon='plusIcon'
              :content="true"
              @click.native="sectionRoute('standingData.productTerms.add')"
          >
            termijn toevoegen
          </dean-section-title-item>
        </dean-section-title>
        <dean-table
            :data='termsData'
            :columns="columns"
            :hover="true"
            @column-click='columnClick'
            @cell-click="cellClick">
        </dean-table>
        <dean-pagination
            :current-page='termsMetaData.pageNumber'
            :total-items='termsMetaData.totalResults'
            :items-per-page='termsMetaData.itemsPerPage'
            :select-items-per-page='selectItemsPerPage'
            :visible-pages='termsMetaData.visiblePages'
            @page-changed='paginationChanged'
            @items-per-page='itemsPerPageChanged'
        >
        </dean-pagination>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import {Vue, Component} from 'vue-property-decorator';
import deanTableMixin from '@/mixins/deanTableMixin';
import {mixins} from 'vue-class-component';
import axios from 'axios';


import {
  // ICONS
  plusIcon,
  // COMPONENTS
  deanSectionTitle,
  deanSectionTitleItem,
  deanTable,
  deanPagination,
} from '@deanone/dean-components';

@Component({
  components: {
    plusIcon,
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
    deanPagination,
  },
})

export default class List extends mixins(deanTableMixin) {
  // DATA
  public terms: object[] = [];
  public standingDataCategories = this.$store.getters.getStandingDataCategories;
  public plusIcon: object = plusIcon;

  public termsSideMenu: object = {
    title: {
      text: 'Producttermijnen',
      mobile: {
        close: {
          text: 'Close',
        },
      },
    },
    filters: {},
  };

  public columns: any = {
    name: {
      content: 'Naam',
      align: 'left',
      sort: true,
      dql: 'name',
    },
    length: {
      content: 'Aantal',
      align: 'left',
      sort: true,
      dql: 'length',
    },
    unit: {
      content: 'Eenheid',
      align: 'left',
      sort: true,
      dql: 'unit',
    },
  };

  // COMPUTED
  get termsData() {
    return this.terms;
  }

  get termsMetaData() {
    return this.pageMeta;
  }

  public tableName(): string {
    return 'settings-productTerms';
  }

  // METHODS
  public loadList(data: any) {
    this.$store.dispatch('setLoadOverlay', true);

    axios.post('/-/trade/api/settings.productTerm.list', {
          params: {
            meta: this.pageMeta,
          },
        },
    ).then(
        (response) => {
          this.terms = response.data.data.map((item: any) => {
            item.unit = this.$t('units.dates.' + item.unit.toLowerCase());
            return item;
          });
          this.updateMeta(response.data.meta);
          this.$store.dispatch('setLoadOverlay', false);
        },
        (error) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
    );
  }

  public sectionRoute(name: string) {
    this.$router.push({name});
  }

  public cellClick(target: any) {
    this.$router.push({
      name: 'standingData.productTerms.edit',
      params: {id: target.row.id},
    });
  }

  public created() {
    this.setDefaultSort('name');
    this.loadList(this.pageMeta);

    this.$store.dispatch('setStandingDataSideMenu', this.termsSideMenu);
  }
}
</script>
<!-- STYLE -->
<style lang="scss" scoped>
@import '~@deanone/dean-components/src/scss/vars';
</style>
